"use client";

import { useConsolidated } from "@/hooks/useConsolidated";
import { CashflowProvider } from "./CashflowProvider";
import { CashflowTable } from "./CashflowTable";
import { CashflowProjectionsPageHeader } from "./CashflowProjectionsPageHeader";
import { useCashflowContext } from "./CashflowContext";

function ConsolidatedNote() {
  const { effectiveConsolidated, error } = useCashflowContext();
  if (!effectiveConsolidated) return null;

  if (error) {
    return (
      <div className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800">
        {error instanceof Error
          ? error.message
          : "Could not load consolidated cashflow."}
      </div>
    );
  }

  return (
    <p className="text-xs text-slate-500 max-w-3xl leading-relaxed">
      ECB reference rates (indicative). All currencies are converted to your
      selected display currency.
    </p>
  );
}

export function CashflowTabsLayout() {
  const { effectiveConsolidated } = useConsolidated();

  return (
    <CashflowProvider>
      <div className="space-y-6 w-full pb-5">
        <CashflowProjectionsPageHeader />
        <CashflowTable />
        {effectiveConsolidated ? <ConsolidatedNote /> : null}
      </div>
    </CashflowProvider>
  );
}
